export default __webpack_public_path__ + "static/media/planet7.41069a49.webp";